<template>
  <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 444 30" width="444" height="30">
    <path fill-rule="evenodd" class="s0" d="m1184-100h-1920v100h736.7c12.4 0.7 24.5 7.8 36.7 15 12.8 7.5 25.6 15 38.6 15h291.7c13 0 25.8-7.5 38.6-15 12.2-7.2 24.3-14.3 36.7-15h741z"/>
  </svg>
</template>